import { SELECT_OCORRENCIA } from '../actions/ordem-coleta.actions'

const initialOrdemColetaState = {
  tabIndex: 0,
  identifier: '',
}

export default function (state = initialOrdemColetaState, action) {
  switch (action.type) {
    case SELECT_OCORRENCIA:
      return {
        ...state,
        tabIndex: action.payload.tabIndex,
        identifier: action.payload.identifier,
      }
    default:
      return state
  }
}
